export default "__VITE_ASSET__1mvdwUhS__"